module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-Light.3cae88f8.eot";